export default __webpack_public_path__ + "static/media/arena_8.f2e50f7d.jpeg";